import { SlidersHorizontal } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useAlertsFilterStore } from "../stores";

const AlertsFilterComponent = () => {
  const { t } = useTranslation();
  const {
    alertTypeFilter,
    frequencyFilter,
    setAlertTypeFilter,
    setFrequencyFilter,
  } = useAlertsFilterStore();

  const hasActiveFilters = alertTypeFilter !== null || frequencyFilter !== null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="relative bg-primary/10 text-primary hover:bg-primary/20 lg:bg-secondary lg:hover:bg-secondary/90 lg:text-gray-500">
          <SlidersHorizontal />
          <span className="hidden lg:inline">{t("keys.filters")}</span>
          {hasActiveFilters && (
            <span className="absolute -top-1 -right-1 size-2.5 rounded-full bg-primary" />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="-translate-x-3 sm:-translate-x-6">
        <DropdownMenuGroup>
          <DropdownMenuLabel>
            {t("keys.filter_by.alert_type")}
          </DropdownMenuLabel>
          <DropdownMenuCheckboxItem
            checked={alertTypeFilter === "new_dilemma"}
            onCheckedChange={() =>
              setAlertTypeFilter(
                alertTypeFilter === "new_dilemma" ? null : "new_dilemma",
              )
            }
          >
            {t("modules.alerts.keys.alert_type_new_dilemma")}
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={alertTypeFilter === "focus_dilemma"}
            onCheckedChange={() =>
              setAlertTypeFilter(
                alertTypeFilter === "focus_dilemma" ? null : "focus_dilemma",
              )
            }
          >
            {t("modules.alerts.keys.alert_type_focus_dilemma")}
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={alertTypeFilter === "admin_action"}
            onCheckedChange={() =>
              setAlertTypeFilter(
                alertTypeFilter === "admin_action" ? null : "admin_action",
              )
            }
          >
            {t("modules.alerts.keys.alert_type_admin_action")}
          </DropdownMenuCheckboxItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuLabel>{t("keys.filter_by.frequency")}</DropdownMenuLabel>
          <DropdownMenuCheckboxItem
            checked={frequencyFilter === "immediate"}
            onCheckedChange={() =>
              setFrequencyFilter(
                frequencyFilter === "immediate" ? null : "immediate",
              )
            }
          >
            {t("modules.alerts.keys.frequency_immediate")}
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={frequencyFilter === "weekly"}
            onCheckedChange={() =>
              setFrequencyFilter(frequencyFilter === "weekly" ? null : "weekly")
            }
          >
            {t("modules.alerts.keys.frequency_weekly")}
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={frequencyFilter === "monthly"}
            onCheckedChange={() =>
              setFrequencyFilter(
                frequencyFilter === "monthly" ? null : "monthly",
              )
            }
          >
            {t("modules.alerts.keys.frequency_monthly")}
          </DropdownMenuCheckboxItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AlertsFilterComponent;
